import { render, staticRenderFns } from "./createKeyword.vue?vue&type=template&id=41e63c17&scoped=true&"
import script from "./createKeyword.vue?vue&type=script&lang=ts&"
export * from "./createKeyword.vue?vue&type=script&lang=ts&"
import style0 from "./createKeyword.vue?vue&type=style&index=0&id=41e63c17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e63c17",
  null
  
)

export default component.exports